import { isEmpty } from 'lodash';
import { useCallback, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useGetPublicationList, useParamQuery } from 'src/hooks';
import { formatQuery, lang } from 'src/utils';

import { PUBLICATION_LIST_COLUMN } from '../PublicationPage.interface';

export const useListPublicationListPage = () => {
  const location = useLocation();

  const { activeFilters, onChangeParams } = useParamQuery({
    sort: ['-modified_at', 'location_code'],
  });

  const {
    data: listPublication,
    isLoading,
    hasNextPage,
    fetchNextPage,
    refetch: refetchPublications,
  } = useGetPublicationList(formatQuery(location.search));

  const totalCount = listPublication?.pages[0].totalCount;

  const [activeColumn, setActiveColumn] = useState('');

  const onChangedParams = (label: string, values: string | string[]) => {
    if (label === 'date_range') {
      const startDate = values[0];
      const endDate = values[1];

      onChangeParams('hq.requested_publication_stamp.from', startDate || []);

      onChangeParams('hq.requested_publication_stamp.to', endDate || []);
    } else {
      onChangeParams(label, values);
    }
  };

  const [sorting, setSorting] = useState({
    columnKey: 'modified_at',
    order: 'desc',
  });

  const getNextListPublicationPage = useCallback(() => {
    if (hasNextPage) {
      fetchNextPage();
    }
  }, [fetchNextPage, hasNextPage]);

  const handleSort = (columnKey: string, order: string) => {
    setSorting(() => ({
      columnKey,
      order,
    }));
    setActiveColumn(columnKey);
    onChangeParams('sort', [
      `${order === 'asc' ? columnKey : `-${columnKey}`}`,
    ]);
  };

  const columns = [
    { label: lang.nsn, key: PUBLICATION_LIST_COLUMN.NSN, sortIcon: false },
    {
      label: lang.locationName,
      key: PUBLICATION_LIST_COLUMN.LOCATION_NAME,
      sortIcon: false,
    },
    {
      label: lang.status,
      key: PUBLICATION_LIST_COLUMN.STATUS,
      sortIcon: false,
    },
    {
      label: lang.timeZone,
      key: PUBLICATION_LIST_COLUMN.TIME_ZONE,
      sortIcon: false,
    },
    {
      label: lang.publicationDate,
      key: PUBLICATION_LIST_COLUMN.PUBLICATION_DATE,
      sortIcon: false,
    },
    {
      label: lang.lastModified,
      key: PUBLICATION_LIST_COLUMN.LAST_MODIFIED,
      sortIcon: true,
    },
  ];

  const getTotalResult = useMemo(() => {
    let components = listPublication?.pages.flatMap((page) => page.data);
    let totalResult = components?.length;

    return totalResult;
  }, [listPublication]);

  return {
    listPublication,
    isLoading,
    hasActiveFilters: !isEmpty(activeFilters),
    getNextListPublicationPage,
    onChangeParams: onChangedParams,
    columns,
    handleSort,
    activeColumn,
    sorting,
    hasNextPage,
    refetchPublications,
    totalCount,
    getTotalResult,
  };
};
